const header = document.querySelector<HTMLElement>('.js-header');
const commonRootMargin = '-6% 0% -93.9% 0%';
const threshold = [0, 1];
const themes = ['light', 'dark', 'dark-transparent'];

const callback: IntersectionObserverCallback = (entries) => {
    entries.forEach((entry) => {
        const target = entry.target as HTMLElement;
        const { theme } = target.dataset;
        if (header && entry.isIntersecting) {
            if (!theme) {
                themes.forEach((item) => {
                    header.classList.remove(`header-theme--${item}`);
                });
                return;
            }

            themes
                .filter((item) => item !== theme)
                .forEach((item) => {
                    header.classList.remove(`header-theme--${item}`);
                });
            header.classList.add(`header-theme--${theme}`);
        } else if (header && !entry.isIntersecting) {
            // если сверху фиксированный блок, то событие сверху на него не срабатывает, поэтому нужен обработчик для секции, которая сразу после этого блока
            const { themeNextSection } = target.dataset;

            if (themeNextSection) {
                themes
                    .filter((item) => item !== theme)
                    .forEach((item) => {
                        header.classList.remove(`header-theme--${item}`);
                    });

                if (entry.boundingClientRect.top >= 0) {
                    header.classList.add(`header-theme--${themeNextSection}`);
                }
            }
        }
    });
};

const map = new Map<HTMLElement, IntersectionObserver>();
const observersMap = new Map<string, IntersectionObserver>();

function createThemeObserver(rootMargin: string) {
    return new IntersectionObserver(callback, { rootMargin, threshold });
}

function init(container: Element | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>('.js-header-theme-trigger')).forEach((el) => {
        const rootMargin = el.dataset.themeObserverMargin || commonRootMargin;
        const usedObserver = observersMap.get(rootMargin);
        const observer = usedObserver || createThemeObserver(rootMargin);
        observer.observe(el);

        if (!usedObserver) {
            map.set(el, observer);
            observersMap.set(rootMargin, observer);
        }
    });
}

function destroy(container: Element | Document = document) {
    Array.from(container.querySelectorAll<HTMLElement>('.js-header-theme-trigger')).forEach((el) => {
        const observer = map.get(el);

        if (observer) {
            observer.unobserve(el);
            map.delete(el);
        }
    });

    // observersMap.clear();

    if (header) {
        themes.forEach((item) => {
            header.classList.remove(`header-theme--${item}`);
        });
    }
}

const _module = { init, destroy };

export default _module;
